import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  container: {
    display: 'inline-block',
    position: 'relative',
    overflow: 'hidden',
  },
  imageTag: {
    width: '100%',
    height: 'auto',
    position: 'absolute',
    top: 0,
    left: 0,
  },
});
